// components/FilterHeader.tsx
import React from "react";
import { Link } from "react-router-dom";

interface FilterHeaderProps {
    title: string;
    selectedStatus: string;
    setSelectedStatus: (status: string) => void;
    selectedSort: string;
    setSelectedSort: (sort: string) => void;
    filterYear: number | "All";
    setFilterYear: (year: number | "All") => void;
    filterMonth: number | "All";
    setFilterMonth: (month: number | "All") => void;
}

const PFStatusFilterHeader: React.FC<FilterHeaderProps> = ({
    title,
    selectedStatus,
    setSelectedStatus,
    selectedSort,
    setSelectedSort,
    filterYear,
    setFilterYear,
    filterMonth,
    setFilterMonth,
}) => {
    return (
        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <h5>{title}</h5>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                {/* Year Dropdown */}
                <div className="dropdown me-3">
                    <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                    >
                        {filterYear === "All" ? "All Years" : filterYear}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                        <li>
                            <Link
                                to="#"
                                onClick={() => setFilterYear("All")}
                                className="dropdown-item rounded-1"
                            >
                                All Years
                            </Link>
                        </li>
                        {Array.from({ length: 10 }, (_, i) => {
                            const year = new Date().getFullYear() - 5 + i;
                            return (
                                <li key={year}>
                                    <Link
                                        to="#"
                                        onClick={() => setFilterYear(year)}
                                        className="dropdown-item rounded-1"
                                    >
                                        {year}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>

                {/* Month Dropdown */}
                <div className="dropdown">
                    <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                    >
                        {filterMonth === "All"
                            ? "All Months"
                            : new Date(0, Number(filterMonth) - 1).toLocaleString("default", {
                                month: "long",
                            })}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                        <li>
                            <Link
                                to="#"
                                onClick={() => setFilterMonth("All")}
                                className="dropdown-item rounded-1"
                            >
                                All Months
                            </Link>
                        </li>
                        {Array.from({ length: 12 }, (_, i) => (
                            <li key={i + 1}>
                                <Link
                                    to="#"
                                    onClick={() => setFilterMonth(i + 1)}
                                    className="dropdown-item rounded-1"
                                >
                                    {new Date(0, i).toLocaleString("default", { month: "long" })}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Status Dropdown */}
                <div className="dropdown me-3">
                    <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                    >
                        {selectedStatus
                            ? selectedStatus.charAt(0).toUpperCase() + selectedStatus.slice(1)
                            : "Select Status"}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                        {["All", "active", "inactive"].map((status) => (
                            <li key={status}>
                                <Link
                                    to="#"
                                    onClick={() => setSelectedStatus(status)}
                                    className="dropdown-item rounded-1"
                                >
                                    {status.charAt(0).toUpperCase() + status.slice(1)}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Sort Dropdown */}
                <div className="dropdown me-3">
                    <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                    >
                        {selectedSort ? `Sort By : ${selectedSort}` : "Sort By : Last 7 Days"}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                        {[
                            "Recently Added",
                            "Ascending",
                            "Descending",
                            "Last Month",
                            "Last 7 Days",
                        ].map((sort) => (
                            <li key={sort}>
                                <Link
                                    to="#"
                                    onClick={() => setSelectedSort(sort)}
                                    className="dropdown-item rounded-1"
                                >
                                    {sort}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>


            </div>
        </div>
    );
};

export default PFStatusFilterHeader;
